import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExpensesClassificationsDoc  {
    _originalTypeClassName = "zERP.BO.ExpensesClassificationsDoc";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExpensesClassificationsDoc.translate = translateService;
}
this.ExpensesInvoiceClassification = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ExpensesInvoiceClassification:any;
static setExpensesInvoiceClassification = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExpensesInvoiceClassification == null) $this.ExpensesInvoiceClassification = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExpensesInvoiceClassification.length > 0) {
                    Domain.ExpensesClassificationsDoc.removeExpensesInvoiceClassification($this, $this.ExpensesInvoiceClassification[0]);
                }

                Domain.ExpensesClassificationsDoc.addManyExpensesInvoiceClassification($this, copyItems);
            }
static addManyExpensesInvoiceClassification = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ExpensesClassificationsDoc.addExpensesInvoiceClassification($this, items[i]);
                }
            }
static addExpensesInvoiceClassification = ($this, item) => {
                if ($this.ExpensesInvoiceClassification == null) $this.ExpensesInvoiceClassification = [];
                if (item == null || $this.ExpensesInvoiceClassification.indexOf(item) > -1) return;
                $this.ExpensesInvoiceClassification.push(item);
}
static addRangeExpensesInvoiceClassification = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ExpensesClassificationsDoc.addExpensesInvoiceClassification($this, item));
            }
static removeExpensesInvoiceClassification = ($this, item) => {
                if ($this == null || $this.ExpensesInvoiceClassification == null || $this.ExpensesInvoiceClassification.indexOf(item) === -1) return;
                var _index = $this.ExpensesInvoiceClassification.indexOf(item);
                $this.ExpensesInvoiceClassification.splice(_index, 1);
}
static clearExpensesInvoiceClassification = ($this) => { $this.ExpensesInvoiceClassification = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}